// autoplay deeplink modal video on opening
;
(function () {

    $(document)
        .on('modalOpened', function() {
            var $video = $('.js-c-deeplinks-modal-content-video');
            if (!$video.length) return false;

            // Attach an event listener to trigger the video.
            $video.on('canplaythrough', function() {
                this.play();
            });

            // Check the readystate of the video as sometimes it fires the
            // canplaythrough event before we've attached our listener.
            for (var i = 0; i < $video.length; i++) {
                if ($video[i].readyState > 3) {
                    $video[i].play();
                }
            }
        })

})();